module.exports = __webpack_public_path__ + "static/media/placeholder.374758f4.png";